import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

export default function LoadingInline() {
  return <Box sx={{textAlign: 'center'}}><CircularProgress color="inherit"/></Box>
}
